import { combineReducers } from 'redux';
import { rewardsHistoryReducer } from './pages/RewardsHistoryPage/rewards-history-page.reducer';
import { purchaseHistoryReducer } from './pages/PurchaseHistoryPage/purchase-history-page.reducer';

export const memberToolingReducer = combineReducers({
  rewardsHistory: rewardsHistoryReducer,
  purchaseHistory: purchaseHistoryReducer,
});
